import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RecargasService, Operadora } from 'src/app/services/recargas/recargas.service';

@Component({
  selector: 'app-operadoras-list',
  templateUrl: './operadoras-list.component.html',
  styleUrls: ['./operadoras-list.component.css']
})
export class OperadorasListComponent implements OnInit {

  operadoras: Operadora[] = [];
  loading: boolean = true;
  error: string = '';

  constructor(
    private recargasService: RecargasService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.loadOperadoras();
  }

  /**
   * Carga las operadoras desde el servicio
   */
  async loadOperadoras(): Promise<void> {
    try {
      this.loading = true;
      this.error = '';
      
      const response = await this.recargasService.getOperators();
      
      if (response?.resp) {
        // Filtra solo las operadoras activas y visibles en consola
        this.operadoras = this.recargasService.filterOperatorsForConsole(response.resp);
      } else {
        this.operadoras = [];
      }
      
    } catch (error) {
      console.error('Error loading operadoras:', error);
      this.error = 'Error al cargar las operadoras. Por favor, intente nuevamente.';
      this.operadoras = [];
    } finally {
      this.loading = false;
    }
  }

  /**
   * Maneja la selección de una operadora
   */
  onSelectOperadora(operadora: Operadora): void {
    // Navega a la vista de tipos de operación pasando el código de la operadora
    this.router.navigate(['/console/recargas/tipos', operadora.code], {
      state: { operadora: operadora }
    });
  }

  /**
   * Maneja errores de carga de imagen
   */
  onImageError(event: any): void {
    // Usa una imagen por defecto en caso de error
    event.target.src = '/assets/brandLogos/default.svg';
  }

  /**
   * Recarga la lista de operadoras
   */
  onRetry(): void {
    this.loadOperadoras();
  }

  /**
   * Navega a la página de administración de recargas
   */
  navigateToAdmin(): void {
    this.router.navigate(['/console/recargas-admin']);
  }

  /**
   * TrackBy function para optimizar el rendering del ngFor
   */
  trackByCode(index: number, operadora: Operadora): string {
    return operadora.code;
  }
} 